import { ref } from 'vue'
import { useRouter } from 'vue-router'
import api from '@/api/axios'

export function useCancelCheckin(onBeforeCancel?: () => void) {
  const router = useRouter()
  const isCancelling = ref(false)
  const showCancelDialog = ref(false)

  const cancelCheckin = async (checkinId: number | string) => {
    isCancelling.value = true

    // Stop heartbeat before deleting to avoid a 404 flash from the next heartbeat tick
    if (onBeforeCancel) {
      onBeforeCancel()
    }

    try {
      await api.delete(`/api/checker/checkins/${checkinId}`)
      router.push('/dashboard')
    } catch (error: unknown) {
      console.error('Fehler beim Abbrechen des Check-Ins:', error)
      if (error && typeof error === 'object' && 'response' in error) {
        const axiosError = error as { response?: { status?: number } }
        if (axiosError.response?.status === 404) {
          // Already deleted, just go to dashboard
          router.push('/dashboard')
          return
        }
      }
      alert('Check-In konnte nicht abgebrochen werden. Bitte versuche es erneut.')
    } finally {
      isCancelling.value = false
      showCancelDialog.value = false
    }
  }

  return {
    isCancelling,
    showCancelDialog,
    cancelCheckin
  }
}
